/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { toast } from 'react-toastify';

import { CreatorsAnchors } from '../../../../store/ducks/anchors';
import { getPermissions } from '../../../../services/auth';
import api from '../../../../services/api';
import {
  consultarPerfisErpAtivos,
  csvToTipoDuplicataKeys,
  lojasKeysToArray,
} from '../../../../services/ancorasImportacoesTitulosService';

import Header from '../../../../layout/Header';
import Subheader from '../../../../layout/Subheader';
import Loading from '../../../../components/Loading';
import Form, { toTimeInput } from '../Form';
import useStyles from '../style';

function Visualize({ id }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [perfis, setPerfis] = useState([]);
  const [vinculo, setVinculo] = useState(null);
  const [form, setForm] = useState({});
  const [todasLojas, setTodasLojas] = useState(true);
  const [lojasKeysArr, setLojasKeysArr] = useState([]);

  const carregar = async () => {
    try {
      const [respVinc, listaPerfis] = await Promise.all([
        api.get(`AncorasImportacoesTitulosApisErps/ConsultarId?id=${id}`),
        consultarPerfisErpAtivos(),
      ]);
      const v = respVinc?.data?.resposta;
      if (!v || !v.ancoraImportacaoTituloApiErpId) {
        toast.error('Integracao nao encontrada');
        history.push('/app');
        return;
      }
      setVinculo(v);
      setPerfis(listaPerfis);
      try {
        const respAncora = await api.get(`Ancoras/ConsultarId?id=${v.ancoraId}`);
        const nome = respAncora?.data?.resposta?.nomeFantasia;
        if (nome) dispatch(CreatorsAnchors.changeLastAnchor(nome));
      } catch (_) {}
      const arr = lojasKeysToArray(v.lojasKeys);
      setLojasKeysArr(arr);
      setTodasLojas(arr.length === 0);
      setForm({
        apelido: v.apelido || '',
        importacaoTituloApiErpId: v.importacaoTituloApiErpId || 0,
        clientId: v.clientId || '',
        clientSecret: '',
        tenantSlug: v.tenantSlug || '',
        tipoDuplicataKeys: csvToTipoDuplicataKeys(v.tipoDuplicataKeys),
        horarioGeracaoFull: toTimeInput(v.horarioGeracaoFull),
        horarioGeracaoComplementar: toTimeInput(v.horarioGeracaoComplementar),
        intervaloMinimoMinutos:
          v.intervaloMinimoMinutos !== null && v.intervaloMinimoMinutos !== undefined
            ? v.intervaloMinimoMinutos
            : '',
        status: v.status || 'Ativo',
        enviarBaixaTitulosAntecipados: !!v.enviarBaixaTitulosAntecipados,
        dataUltimaGeracaoFull: v.dataUltimaGeracaoFull || null,
        dataUltimaGeracaoComplementar: v.dataUltimaGeracaoComplementar || null,
      });
    } catch (e) {
      toast.error('Falha ao carregar integracao');
    }
    setLoading(false);
  };

  useEffect(() => {
    dispatch(CreatorsAnchors.changeLastGrid('ancoras-integracoes-titulos'));
    const ok = getPermissions({ moduloId: 58872, permissao: 'Consultar' });
    if (ok) carregar();
    else history.push('/app');
  }, []);

  return (
    <div className={classes.root}>
      <Header />
      <Subheader
        title="Visualizando integracao ERP da rede: "
        loading={loading}
        back={vinculo ? `/app/editar-ancora/${vinculo.ancoraId}` : '/app'}
        subanchor
      />
      <div className={classes.content}>
        <div className={classes.rootForm} style={{ marginLeft: '5%', width: '90%' }}>
          {loading ? (
            <Loading />
          ) : (
            <Form
              mode="visualize"
              form={form}
              onFieldChange={() => {}}
              perfis={perfis}
              todasLojas={todasLojas}
              onToggleTodasLojas={() => {}}
              lojasKeysArr={lojasKeysArr}
              onChangeLojas={() => {}}
              lojasCarregadas={[]}
              carregandoLojas={false}
              onCarregarLojas={() => {}}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default Visualize;
